.expandedContent {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 0;
}

.expandedRow {
    display: flex;
    flex-direction: row;
    gap: 48px;
}

.expandedChartContainer {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 48px;
}

.orange {
    color: var(--hps-dark-orange);
}

.red {
    color: var(--hps-red);
}

.matchLinkPadding {
    padding: 3px 0px;
}

.summaryDashlets {
    display: flex;
    gap: 48px;
    margin: 24px 0px;
}

.summaryDashletColumn {
    flex: 1;
}